import { render, staticRenderFns } from "./DownPaymentExtOrderItemsGrid.vue?vue&type=template&id=570f0fc3&scoped=true&"
import script from "./DownPaymentExtOrderItemsGrid.vue?vue&type=script&lang=ts&"
export * from "./DownPaymentExtOrderItemsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./DownPaymentExtOrderItemsGrid.vue?vue&type=style&index=0&id=570f0fc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f0fc3",
  null
  
)

export default component.exports